export default __webpack_public_path__ + "static/media/background-1.4114ba31.png";